import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { EmailAddressForm } from "./EmailAddress";
import { ResetPasswordForm } from "./ResetPassword";
import { VerifyOTPForm } from "./VerifyOTP";

export const ForgotPasswordContainer: React.FC = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);

  const renderForm = () => {
    switch (step) {
      case 1:
        return (
          <EmailAddressForm
            email={email}
            setEmail={setEmail}
            setStep={setStep}
          />
        );
      case 2:
        return <VerifyOTPForm email={email} setStep={setStep} />;
      case 3:
        return <ResetPasswordForm email={email} setStep={setStep} />;
      default:
        return null;
    }
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        {/* <Col xl="6" className="b-center bg-size p-0 d-none d-xl-block">
          <Image
            className="bg-img-cover bg-center w-100 vh-100"
            src={dynamicImage("login/3.jpg")}
            alt="loginpage"
          />
        </Col> */}
        <Col xl="12" className="p-0">
          <div className="login-card login-dark">
            <div className="login-main">{renderForm()}</div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
